import * as React from 'react'
import { useMemo } from 'react'
import { useVerificationCountWidget } from './hooks'
import { Card, Statistic, Flex, Spin, Tooltip } from 'antd'
import { SafetyCertificateOutlined } from '@ant-design/icons'
import { Column } from '@ant-design/plots'
import { path } from '../../../../libs'

export const VerificationCountWidget = () => {
  const { verificationCount, verificationCountByMonth, loading } =
    useVerificationCountWidget()

  const chartData = useMemo(() => {
    const items = Array.isArray(verificationCountByMonth)
      ? verificationCountByMonth
      : []
    return [...items]
      .sort(
        (a, b) =>
          new Date(a.txn_month.split(' ')[0]).getTime() -
          new Date(b.txn_month.split(' ')[0]).getTime(),
      )
      .map((d) => ({
        date: d.txn_month.split(' ')[0],
        count: d.request_count,
      }))
  }, [verificationCountByMonth])

  return (
    <Card size="small" style={{ flex: 1, minWidth: 320 }}>
      <Spin spinning={loading}>
        <Statistic
          title={
            <Flex align="center" gap={6}>
              <SafetyCertificateOutlined style={{ color: '#ef4444' }} />
              <Tooltip title="Общее количество заявок на верификацию. График — новые заявки по месяцам.">
                <a
                  target="_blank"
                  href={path.verificationsV2.entry()}
                  style={{ fontSize: 12, color: 'inherit' }}
                >
                  Verification requests
                </a>
              </Tooltip>
            </Flex>
          }
          value={verificationCount.count.toLocaleString('ru-RU')}
          valueStyle={{
            fontSize: 28,
            fontFamily: 'monospace',
            fontWeight: 600,
          }}
        />
        {chartData.length > 1 && (
          <div style={{ height: 180, marginTop: 12 }}>
            <Column
              data={chartData}
              xField="date"
              yField="count"
              height={180}
              style={{ fill: '#ef4444' }}
              axis={{
                x: {
                  label: {
                    style: { fontSize: 10 },
                    autoRotate: true,
                    formatter: (v: string) => {
                      const d = new Date(v)
                      return d.toLocaleDateString('ru-RU', { month: 'short', year: '2-digit' })
                    },
                  },
                },
                y: {
                  label: {
                    style: { fontSize: 10 },
                  },
                },
              }}
              legend={false}
              tooltip={(d: { date: string; count: number }) => ({
                name: 'Requests',
                value: d.count,
              })}
            />
          </div>
        )}
      </Spin>
    </Card>
  )
}
